export const SectionHeading = ({ overline, title, kicker, align = "left" }) => {
    const alignClass = align === "center" ? "text-center mx-auto" : "text-left";
    return (
        <div className={`max-w-3xl ${alignClass}`}>
            {overline && (
                <p className="text-[10px] uppercase tracking-[0.35em] text-[#C5A059]">
                    {overline}
                </p>
            )}
            <h2 className="mt-4 font-heading text-3xl sm:text-4xl lg:text-5xl text-[#E8E3D9] leading-[1.05] tracking-tight">
                {title}
            </h2>
            {kicker && (
                <p className="mt-5 text-[#A39E93] text-base md:text-lg font-light leading-relaxed max-w-2xl">
                    {kicker}
                </p>
            )}
        </div>
    );
};
